import { render, staticRenderFns } from "./DeleteMsuFromGroup.vue?vue&type=template&id=4abf4530"
import script from "./DeleteMsuFromGroup.vue?vue&type=script&lang=js"
export * from "./DeleteMsuFromGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports